/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BackupApiService } from '../http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class StorageListResolvers {
    constructor(
        private backupApiService: BackupApiService,
    ) {
    }

    public resolve(): Observable<any> {
        return new Observable<any>(observe => {
            this.backupApiService.getBackupsByNamespaceId(0)
                .subscribe(
                    data => {
                        observe.next(data);
                        observe.complete();
                    },
                    () => {
                        observe.next([]);
                        observe.complete();
                    });
        });
    }
}
